<template>
  <v-sheet color="white" class="rounded-lg shadow">
    <v-sheet color="white" class="my-3 rounded-lg shadow">
      <v-container fluid fill-width class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
          <v-col cols="8" class="ma-0 pa-0">
            <v-switch
              v-model="editMode"
              :label="
                'Edit Table  (' +
                  nSelectedVars +
                  '/' +
                  allVars.length +
                  ' characteristics and ' +
                  nSelectedCols +
                  '/' +
                  nTotalCols +
                  ' columns selected)'
              "
              class="ma-0 pa-0 pl-2 d-inline-block"
            ></v-switch>

            <v-radio-group
              v-if="editMode"
              v-model="summaryStat"
              label="Summary statistic: "
              hide-details
              row
              class="ma-0 pa-0 pl-2 pb-4"
            >
              <v-radio
                v-for="m in summaryStats"
                :key="m.value"
                :label="m.label"
                :value="m"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col v-if="!hideExportButton" cols="4" class="ma-0 pa-0 text-right">
            <v-btn
              small
              class="primary mx-2 pr-2"
              @click="exportTableDialog = true"
              ><v-icon left>mdi-download</v-icon>Export table</v-btn
            >
          </v-col>
        </v-row>

        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <VueHtml2pdf
              ref="vdt"
              :manual-pagination="true"
              :float-layout="false"
              :enabled-download="true"
              :preview-modal="false"
              :filename="pdfFilename"
              :pdf-format="pdfFormat"
              :pdf-orientation="pdfOrientation"
              pdf-content-width="100%"
            >
              <section slot="pdf-content">
                <v-checkbox
                  v-if="editMode"
                  v-model="showEmptyCats"
                  label="show categories with no subjects"
                  dense
                  hide-details
                  class="ma-0 pa-0 pl-2 d-inline-block"
                ></v-checkbox>

                <v-checkbox
                  v-if="editMode"
                  v-model="showTitle"
                  label="show title:"
                  dense
                  hide-details
                  class="pa-0 ma-0 pl-2"
                ></v-checkbox>
                <h3 v-if="showTitle || editMode" :class="getTitleClass()">
                  &nbsp;{{ title }}
                </h3>
                <v-data-table
                  :headers="colHeaders"
                  :items="
                    allVars.filter(
                      v =>
                        (selectedVars[v.id] || editMode) &&
                        (!(v.id in groupVarId2Primary) ||
                          v.id === groupVarId2Primary[v.id])
                    )
                  "
                  item-key="id"
                  :disable-pagination="true"
                  :hide-default-footer="true"
                  :hide-default-header="true"
                  dense
                >
                  <template v-slot:header="props">
                    <thead>
                      <tr :key="props.index">
                        <th v-if="editMode" style="vertical-align: text-top;">
                          <span class="subtitle-2 black--text">
                            <!-- include all checkbox? -->
                          </span>
                        </th>
                        <th
                          v-for="c in colHeaders.filter(
                            h =>
                              (selectedCols[h.id] &&
                                (h.text != 'p-Value' || allCohortsSelected)) ||
                              h.text == 'Sample characteristic' ||
                              editMode
                          )"
                          :key="c.id"
                          :class="getThClass(selectedCols[c.id], c) + ' pl-1'"
                          style="vertical-align: text-top;"
                        >
                          <span
                            v-if="c.text == 'Sample characteristic'"
                            class="subtitle-2 black--text"
                            ><br
                          /></span>
                          <v-checkbox
                            v-else-if="editMode"
                            :input-value="selectedCols[c.id]"
                            dense
                            hide-details
                            class="pa-0 ma-0"
                            @change="selectColumn(c, $event)"
                          ></v-checkbox>

                          <div>
                            <svg
                              width="50"
                              height="25"
                              class="mt-1"
                              :style="getSvgStyle(selectedCols[c.id])"
                              data-html2canvas-ignore
                            >
                              <g v-if="col2Cohort[c.id]">
                                <rect
                                  x="0"
                                  y="0"
                                  rx="0"
                                  ry="0"
                                  border-radius="0%"
                                  width="50"
                                  height="25"
                                  :fill="col2Cohort[c.id]['color']"
                                  stroke="black"
                                />
                                <rect
                                  v-if="col2Cohort[c.id]['pattern'] != null"
                                  x="0"
                                  y="0"
                                  rx="0"
                                  ry="0"
                                  border-radius="0%"
                                  width="50"
                                  height="25"
                                  :fill="
                                    'url(#' +
                                      col2Cohort[c.id]['pattern']['id'] +
                                      ')'
                                  "
                                />
                              </g>
                            </svg>
                          </div>

                          <span
                            :class="
                              getColTitleClass(
                                selectedCols[c.id] ||
                                  c.text == 'Sample characteristic',
                                c
                              )
                            "
                          >
                            <span
                              :style="
                                getColTitleStyle(
                                  selectedCols[c.id] ||
                                    c.text == 'Sample characteristic',
                                  c
                                )
                              "
                              >{{ c.text
                              }}{{ c.text == 'p-Value' ? '*' : '' }}</span
                            ></span
                          >
                          <br />
                          <span
                            v-if="
                              c.text != 'Sample characteristic' &&
                                c.text != 'p-Value'
                            "
                            :class="getColTitleCountClass(selectedCols[c.id])"
                            :style="getColTitleCountStyle(selectedCols[c.id])"
                            >(n={{
                              displayMode === 'table1'
                                ? data.length
                                : cohortSize(c.id)
                            }})</span
                          >
                        </th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:item="v">
                    <tr
                      :key="v.index"
                      :class="getTRClass(v.item)"
                      @click="tableRowClick(v.item)"
                    >
                      <td v-if="editMode">
                        <v-checkbox
                          v-if="editMode"
                          :input-value="selectedVars[v.item.id]"
                          dense
                          hide-details
                          class="pa-0 ma-0"
                          @change="selectVar(v, $event)"
                        ></v-checkbox>
                      </td>
                      <td :class="getTdClass(true, selectedVars[v.item.id])">
                        <span
                          :class="getVarNameClass(selectedVars[v.item.id])"
                          :style="getVarNameStyle(selectedVars[v.item.id])"
                          >{{ getVariableName(v.item) }}</span
                        >
                        <span
                          v-for="(cc, cc_index) in sampleCounts(
                            col2CohortId[2],
                            col2Axis[2],
                            v.item
                          )"
                          :key="`ds1-${cc_index}`"
                          class="pl-0"
                        >
                          <br />
                          <span> {{ '&nbsp;&nbsp;&nbsp;' + cc.label }} </span>
                        </span>
                      </td>
                      <td
                        v-for="(cnum, cn) in tableCols.filter(
                          k =>
                            editMode ||
                            (selectedCols[k] &&
                              (colHeaders[k - 1].text !== 'p-Value' ||
                                allCohortsSelected))
                        )"
                        :key="`trd-${v.item.id}-${cn}`"
                        :class="
                          getTdClass(
                            selectedCols[cnum],
                            selectedVars[v.item.id],
                            v.item
                          ) + ' pl-1'
                        "
                      >
                        <!-- table 1: display empty cell for last visit for predictor variables -->
                        <span
                          v-if="
                            displayMode === 'table1' &&
                              col2Axis[cnum] == 'right_y_axis' &&
                              !v.item.is_longitudinal &&
                              selectedCols[2]
                          "
                        >
                        </span>
                        <span v-else>
                          <!-- table 1: p-value column -->
                          <span
                            v-if="displayMode === 'table1' && cnum === 4"
                            class="subtitle-3"
                          >
                            {{
                              sampleTtestPval(
                                col2CohortId[cnum],
                                'right_y_axis',
                                v.item
                              )
                            }}
                          </span>
                          <!-- table 2: p-value column -->
                          <v-tooltip
                            v-else-if="
                              displayMode === 'table2' &&
                                colHeaders[cnum - 1].text === 'p-Value'
                            "
                            top
                            color="primary"
                          >
                            <template v-slot:activator="{ on: tooltip }">
                              <span class="subtitle-3" v-on="{ ...tooltip }">
                                {{
                                  allCohortsSelected
                                    ? format_pval(getPval(v.item))
                                    : ''
                                }}
                              </span>
                            </template>
                            <span
                              >p-Value from
                              {{
                                v.item.label in pvalDict
                                  ? pvalDict[v.item.label].test_name
                                  : v.item.label
                              }}</span
                            >
                          </v-tooltip>
                          <!-- continuous variable -->
                          <span
                            v-else-if="v.item.data_category === 'Continuous'"
                            class="subtitle-3"
                            >{{
                              summaryStat.value == 'mean_sd'
                                ? sampleMean(
                                    col2CohortId[cnum],
                                    col2Axis[cnum],
                                    v.item
                                  ) +
                                  '&nbsp;&#177;' +
                                  sampleDeviation(
                                    col2CohortId[cnum],
                                    col2Axis[cnum],
                                    v.item
                                  )
                                : sampleMedian(
                                    col2CohortId[cnum],
                                    col2Axis[cnum],
                                    v.item
                                  ) +
                                  ' (' +
                                  sampleIQR(
                                    col2CohortId[cnum],
                                    col2Axis[cnum],
                                    v.item
                                  ) +
                                  ')'
                            }}
                          </span>
                          <!-- categorical variable -->
                          <span
                            v-for="(cc, cc_index) in sampleCounts(
                              col2CohortId[cnum],
                              col2Axis[cnum],
                              v.item
                            )"
                            v-else
                            :key="`ds2-${cc_index}`"
                          >
                            <br />
                            <span class="subtitle-3 pt-1 pl-0">{{
                              cc.count + '&nbsp;(' + cc.percent + '%)'
                            }}</span>
                          </span>
                        </span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

                <div v-if="showFootnotes || editMode">
                  <v-checkbox
                    v-if="editMode"
                    v-model="showFootnotes"
                    label="show footnote(s):"
                    dense
                    hide-details
                    class="pa-1 pt-2 ma-0"
                  ></v-checkbox>

                  <div
                    v-if="displayMode == 'table1' && pvalVisible"
                    :class="getFootnoteClass()"
                  >
                    &nbsp;* - p-Value from t-test comparing first visit
                    (baseline) and last visit, computed with
                    <a href="https://www.npmjs.com/package/ttest"
                      >https://www.npmjs.com/package/ttest</a
                    >
                  </div>
                  <div
                    v-else-if="displayMode == 'table2' && pvalColSelected"
                    :class="getFootnoteClass()"
                  >
                    <span v-if="!allCohortsSelected"
                      >* - p-Value for all study group comparison not shown
                      because not all study groups are selected</span
                    >
                    <span v-else
                      >* - p-Value from a comparison of all study groups using
                      the test specified in the OUTCOME VARIABLES/ANALYTICS
                      tab</span
                    >
                  </div>
                </div>
              </section>
            </VueHtml2pdf>

            <export-table-dialog
              :show="exportTableDialog"
              :default-filename-prefix="getDefaultDownloadPrefix()"
              @dialogClosed="exportTableDialog = false"
              @exportTable="exportTable"
            >
            </export-table-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { state } from '@/store/modules/dataExplorer/types';
import { mean, median, deviation, quantile, ascending } from 'd3-array';
import { format } from 'd3-format';
import { colors } from '@/utils/colors';
import { sortScales, getSetValuedVariableGroups } from '@/utils/helpers';
import ExportTableDialog from '@/components/common/ExportTableDialog.vue';
import 'd3-transition';
import VueHtml2pdf from 'vue-html2pdf';

var ttest = require('ttest');

const SUMMARY_STATS = [
  {
    label: 'Mean +/- SD',
    value: 'mean_sd',
    descr: 'Mean plus or minus standard deviation',
  },
  {
    label: 'Median and IQR',
    value: 'median',
    descr: 'Median and interquartile range',
  },
];

export default {
  components: {
    ExportTableDialog,
    VueHtml2pdf,
  },
  props: {
    hideExportButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Summary statistics',
    },
    displayMode: {
      type: String,
      required: true,
      default: 'table1', // either table1 or table2
    },
    cohorts: {
      type: Array,
      required: true,
      default: () => [],
    },
    visibleCohorts: {
      type: Array,
      required: false,
      default: () => [],
    },
    predictorVariables: {
      type: Array,
      required: true,
      default: () => [],
    },
    outcomeVariables: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedVariables: {
      type: Array,
      required: false,
      default: () => [],
    },
    comparisonField: {
      type: String,
      required: true,
    },
    isLongitudinal: {
      type: Boolean,
      required: false,
      default: true,
    },
    analysis: {
      type: Object,
      required: true,
      default: () => {},
    },
    anovaPvals: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedAnalysisMode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      allVars: [],
      variableGroups: { groups: [], var2group: {}, var2var: {} },
      groupVarId2Primary: [],
      editMode: false,
      showEmptyCats: false,
      selectedVars: {},
      tableCols: this.isLongitudinal ? [2, 3, 4] : [2],
      selectedCols: {},
      nSelectedCols: 0,
      first_n_last: ['left_y_axis', 'right_y_axis'],
      col2Axis: { 2: 'left_y_axis', 3: 'right_y_axis' },
      col2CohortId: { 2: 'all', 3: 'all', 4: 'all' },
      col2Cohort: {},
      nSelectedVars: 0,
      colors: colors,
      sampleStats: {},
      dimension2field: {
        left_y_axis: 'firstVisit',
        right_y_axis: 'lastVisit',
        change: 'change',
        roc: 'roc',
        '': 'value',
      },
      field2dimension: {
        firstVisit: 'left_y_axis',
        lastVisit: 'right_y_axis',
        change: 'change',
        roc: 'roc',
        value: '',
      },
      var2visits: {},
      colHeaders: [],
      summaryStats: SUMMARY_STATS,
      summaryStat: SUMMARY_STATS[0],
      exportTableDialog: false,
      pdfFilename: 'table',
      pdfFormat: 'letter',
      pdfOrientation: 'portrait',
      highlightSelectedVar: true,
      showFootnotes: true,
      showTitle: false,
      pvalDict: {},
    };
  },
  computed: {
    ...mapState('dataExplorer', {
      collection: state.COLLECTION,
      data: state.DATA,
    }),
    nTotalCols() {
      if (this.displayMode === 'table1') {
        return this.isLongitudinal ? '3' : '1';
      } else {
        return this.cohorts.length + 2;
      }
    },
    allCohortsSelected() {
      let acs = true;
      Object.keys(this.col2Cohort).forEach(col => {
        let cht = this.col2Cohort[col];
        if (cht.id != 'all') {
          if (!(col in this.selectedCols)) acs = false;
        }
      });
      return acs;
    },
    pvalColSelected() {
      let pvalHeaders = this.colHeaders.filter(ch => ch.text == 'p-Value');
      if (pvalHeaders.length == 1) {
        return this.selectedCols[pvalHeaders[0].id];
      } else {
        return false;
      }
    },
    pvalVisible() {
      return this.pvalColSelected && this.allCohortsSelected;
    },
  },
  watch: {
    cohorts() {
      this.resetSelectedCols();
      this.updateSampleStats();
    },
    visibleCohorts(vc) {
      this.updateVisibleCohorts(vc);
    },
    collection(new_collection) {
      this.updateVisits(new_collection);
    },
    predictorVariables() {
      this.updateAllVars();
      this.updateSampleStats();
    },
    outcomeVariables() {
      this.updateAllVars();
      this.updateSampleStats();
    },
    data() {
      this.updateSampleStats();
    },
    summaryStat() {
      this.updateHeaders();
    },
    displayMode() {
      this.updateHeaders();
      this.updateSampleStats();
    },
    selectedVariables() {
      this.updateTable();
    },
    anovaPvals() {
      this.updatePvalDict();
    },
    showEmptyCats() {
      this.updateSampleStats();
    },
  },
  mounted() {
    this.resetSelectedCols();
    this.updateHeaders();
    this.updateAllVars();
    this.updateVisits(this.collection);
    this.updateSampleStats();
    this.nSelectedVars = 0;
    this.allVars.forEach(v => {
      this.selectedVars[v.id] = true;
      this.nSelectedVars += 1;
    });
    this.updatePvalDict();
  },
  methods: {
    updateTable() {
      this.allVars.splice(0, 1, this.allVars[0]);
    },
    resetSelectedCols() {
      if (this.displayMode === 'table1') {
        this.tableCols = this.isLongitudinal ? [2, 3, 4] : [2];
        this.selectedCols = {
          2: true,
          3: this.isLongitudinal,
          4: this.isLongitudinal,
        };
        this.nSelectedCols = this.isLongitudinal ? 3 : 1;
        this.col2CohortId = { 2: 'all', 3: 'all', 4: 'all' };
      } else if (this.displayMode === 'table2') {
        let cnum = 1;
        let sc = {};
        let c2c = {};
        let c2cht = {};
        let c2a = {};
        let tc = [];
        let fdim = this.field2dimension[this.comparisonField];
        let cohorts = [{ id: 'all' }, ...this.cohorts];
        let cid2c = {};
        this.cohorts.forEach(c => {
          cid2c[c.id] = c;
        });
        cohorts.forEach(c => {
          cnum += 1;
          sc[cnum] = true;
          c2c[cnum] = c.id;
          if (c.id in cid2c) {
            c2cht[cnum] = cid2c[c.id];
          }
          tc.push(cnum);
          c2a[cnum] = fdim;
        });
        // p-value
        sc[cnum + 1] = true;
        tc.push(cnum + 1);

        this.tableCols = tc;
        this.selectedCols = sc;
        this.nSelectedCols = cnum;
        this.col2CohortId = c2c;
        this.col2Cohort = c2cht;
        this.col2Axis = c2a;
      }
    },
    updateVisibleCohorts(vc) {
      if (this.displayMode === 'table2') {
        let vis = {};
        vc.forEach(c => {
          vis[c.id] = 1;
        });
        let sc = {};
        let nsel = 0;
        if (this.selectedCols[2]) {
          sc[2] = true;
          nsel += 1;
        }
        for (let cnum = 3; cnum < 3 + this.cohorts.length; cnum++) {
          let cid = this.col2CohortId[cnum];
          if (cid in vis) {
            sc[cnum] = true;
            nsel += 1;
          } else {
            if (cnum in sc) {
              delete sc[cnum];
            }
          }
        }
        // p-value column
        if (this.selectedCols[3 + this.cohorts.length]) {
          sc[3 + this.cohorts.length] = true;
          nsel += 1;
        }

        this.selectedCols = sc;
        this.nSelectedCols = nsel;
      }
    },
    updateAllVars() {
      if (this.selectedAnalysisMode == 'Predictor based') {
        this.allVars = sortScales([
          ...this.predictorVariables.filter(
            v => !('observation_ontology' in v) && v.value_type !== 'date'
          ),
          ...this.outcomeVariables,
        ]);
      } else {
        // note - outcomes analysis has 4 "hidden" predictor variables, compress them into 1 "dummy" variable
        // copy over attributes to "dummy" variable
        let predictorVar = this.predictorVariables[0].observation_ontology;
        predictorVar.is_longitudinal = this.predictorVariables[0].is_longitudinal;
        let sortedVars = sortScales([
          ...this.outcomeVariables.filter(v => v.value_type !== 'date'),
        ]);
        this.allVars = [predictorVar, ...sortedVars];
      }
      // update grouped vars
      const varGroups = getSetValuedVariableGroups(this.allVars);
      this.variableGroups = varGroups;

      // map group members to primary variable id
      let id2primary = {};
      varGroups['groups'].forEach(vg => {
        const vars = vg['vars'];
        const primary_id = vars[0]['var']['id'];
        vars.forEach(v => {
          id2primary[v['var']['id']] = primary_id;
        });
      });
      this.groupVarId2Primary = id2primary;
    },
    updateSampleStats() {
      if (
        this.cohorts == null ||
        this.outcomeVariables == null ||
        this.data == null
      )
        return;

      let sstats = {};

      // index cohort subjects
      var cohortSubjs = {};
      if (this.displayMode === 'table2') {
        this.cohorts.forEach(c => {
          cohortSubjs[c.id] = {};
          c.subject_ids.forEach(sid => {
            cohortSubjs[c.id][sid] = 1;
          });
        });
      }
      var sampleData = {};
      let visits =
        this.displayMode === 'table1'
          ? this.first_n_last
          : [this.field2dimension[this.comparisonField]];

      let cohorts =
        this.displayMode === 'table1'
          ? [{ id: 'all' }]
          : [{ id: 'all' }, ...this.cohorts];

      let self = this;
      let add_datum = function(cohort, visit, datum) {
        if (!(cohort.id in sampleData)) {
          sampleData[cohort.id] = {};
        }
        if (!(visit in sampleData[cohort.id])) {
          sampleData[cohort.id][visit] = {};
        }

        var cfield = self.isLongitudinal
          ? self.dimension2field[visit]
          : 'value';

        self.predictorVariables.forEach(pv => {
          if (pv.type == 'observation' || 'dimension_label' in pv) {
            var ont_id = pv.observation_ontology.id;
            // var key = ont_id + '_' + pv.dimension_label;
            var key = ont_id;

            if (!(key in sampleData[cohort.id][visit])) {
              sampleData[cohort.id][visit][key] = [];
            }

            sampleData[cohort.id][visit][key].push(datum[ont_id][cfield]);
          } else if (pv.type == 'subject') {
            var oo_id = pv.id;
            var pval =
              pv.label == 'Dataset' ? datum.study.study_name : datum[pv.label];
            if (!(oo_id in sampleData[cohort.id][visit]))
              sampleData[cohort.id][visit][oo_id] = [];
            sampleData[cohort.id][visit][oo_id].push(pval);
          }
        });

        self.outcomeVariables.forEach(ov => {
          if (ov.type == 'observation') {
            if (!(ov.id in sampleData[cohort.id][visit])) {
              sampleData[cohort.id][visit][ov.id] = [];
            }
            // special case for 'change' in categorical vars
            if (visit == 'change' && ov.data_category != 'Continuous') {
              let cval =
                datum[ov.id]['firstVisit'] == datum[ov.id]['lastVisit']
                  ? 'unchanged'
                  : 'changed';
              sampleData[cohort.id][visit][ov.id].push(cval);
            } else {
              sampleData[cohort.id][visit][ov.id].push(datum[ov.id][cfield]);
            }
          } else if (
            self.selectedAnalysisMode == 'Outcome based' &&
            ov.type == 'subject'
          ) {
            var oo_id = ov.id;
            var oval =
              ov.label == 'Dataset' ? datum.study.study_name : datum[ov.label];
            if (!(oo_id in sampleData[cohort.id][visit]))
              sampleData[cohort.id][visit][oo_id] = [];
            sampleData[cohort.id][visit][oo_id].push(oval);
          }
        });
      };

      // iterate over all cohorts and visits, grouping data by cohort, visit, and variable
      this.data.forEach(d => {
        var subjId = d.subject_id;
        cohorts.forEach(cht => {
          // is subjId in this cohort?
          if (cht.id === 'all' || subjId in cohortSubjs[cht.id]) {
            visits.forEach(visit => {
              add_datum(cht, visit, d);
            });
          }
        });
      });

      // track data for running table1 t-test
      let tt_data = {};
      this.first_n_last.forEach(visit => {
        tt_data[visit] = {};
      });

      // second pass to compute summary stats
      cohorts.forEach(cht => {
        sstats[cht.id] = {};
        visits.forEach(visit => {
          sstats[cht.id][visit] = {};
          this.allVars.forEach(ov => {
            if (ov.data_category === 'Continuous') {
              let key = ov.id;
              sstats[cht.id][visit][key] = {};
              let cdata = sampleData[cht.id][visit][key].sort(ascending);

              sstats[cht.id][visit][key]['mean'] = format('.1~f')(mean(cdata));
              sstats[cht.id][visit][key]['median'] = format('.1~f')(
                median(cdata)
              );
              sstats[cht.id][visit][key]['iqr'] = format('.1~f')(
                quantile(cdata, 0.75) - quantile(cdata, 0.25)
              );
              sstats[cht.id][visit][key]['deviation'] = format('.1~f')(
                deviation(cdata)
              );

              // run t-test
              if (this.displayMode === 'table1') {
                tt_data[visit][ov.id] = cdata;
                if (visit === 'right_y_axis') {
                  let cd1 = tt_data['left_y_axis'][ov.id];
                  let ttr = ttest(cd1, cdata);
                  let ttpv = ttr.pValue();
                  if (ttpv > 0.01) {
                    ttpv = format('.2~f')(ttpv);
                  } else if (ttpv >= 0.001) {
                    ttpv = format('.3~f')(ttpv);
                  } else {
                    ttpv = '<0.001';
                  }
                  sstats[cht.id][visit][key]['ttest_pval'] = ttpv;
                }
              }
            }
            // categorical and ordinal vars
            else {
              let key = null;

              if ('observation_ontology' in ov) {
                key = ov.observation_ontology.id;
              } else if ('subject_ontology' in ov) {
                key = ov.subject_ontology.id;
              } else {
                key = ov.id;
              }
              // where to accumulate the counts
              let target_key = key;

              // count everything under primary group var
              if (key in this.groupVarId2Primary) {
                target_key = this.groupVarId2Primary[key];
              }
              let cdata = sampleData[cht.id][visit][key];
              if (cdata == null) {
                cdata = [];
              }
              var counts = {};

              // initialize counts with existing value
              if (target_key in sstats[cht.id][visit]) {
                let o_counts = sstats[cht.id][visit][target_key]['counts'];
                o_counts.map(cl => {
                  counts[cl.label] = cl.count;
                });
              } else {
                sstats[cht.id][visit][target_key] = {};
              }
              let cdata_f =
                key in this.groupVarId2Primary
                  ? cdata.filter(c => c != 'N/A')
                  : cdata;

              cdata_f.forEach(c => {
                if (!(c in counts)) counts[c] = 0;
                counts[c] += 1;
              });
              var clist = [];
              var catsSeen = {};
              // sort and calculate percentages
              Object.keys(counts)
                .sort((a, b) => counts[b] - counts[a])
                .forEach(k => {
                  let ct = counts[k];
                  let pct = format('.1~f')((ct / cdata.length) * 100);
                  clist.push({ label: k, count: ct, percent: pct });
                  catsSeen[k] = 1;
                });

              // add zero counts for any category not observed in the cohort
              if (
                cht.id != 'all' &&
                'counts' in sstats['all'][visit][target_key]
              ) {
                sstats['all'][visit][target_key]['counts'].forEach(ct => {
                  if (!(ct['label'] in catsSeen)) {
                    clist.push({ label: ct['label'], count: 0, percent: 0 });
                  }
                });
              }

              sstats[cht.id][visit][target_key]['counts'] = clist;
            }
          });
        });
      });

      // filter categories with count = 0 in all cohorts
      if (this.displayMode === 'table2' && !this.showEmptyCats) {
        let empty_cats = {};
        Object.keys(sstats['all']).forEach(dim => {
          empty_cats[dim] = {};
          Object.keys(sstats['all'][dim]).forEach(v_id => {
            empty_cats[dim][v_id] = {};
            if ('counts' in sstats['all'][dim][v_id]) {
              // sum counts over all cohorts
              let cat_counts = {};
              sstats['all'][dim][v_id]['counts'].forEach(cat => {
                cat_counts[cat.label] = 0;
              });
              this.cohorts.forEach(c => {
                if (c.id in sstats && dim in sstats[c.id]) {
                  sstats[c.id][dim][v_id]['counts'].forEach(cat => {
                    cat_counts[cat.label] += cat.count;
                  });
                }
              });

              Object.keys(cat_counts).forEach(k => {
                let cc = cat_counts[k];
                if (cc === 0) {
                  empty_cats[dim][v_id][k] = 1;
                }
              });
            }
          });
        });

        // remove the empty categories
        Object.keys(sstats).forEach(cid => {
          Object.keys(sstats[cid]).forEach(dim => {
            Object.keys(sstats[cid][dim]).forEach(v_id => {
              if ('counts' in sstats[cid][dim][v_id]) {
                let filtered_counts = sstats[cid][dim][v_id]['counts'].filter(
                  cat => !(cat.label in empty_cats[dim][v_id])
                );
                sstats[cid][dim][v_id]['counts'] = filtered_counts;
              }
            });
          });
        });
      }
      this.sampleStats = sstats;
    },

    // cohort_id = cohort.id or 'all'
    // dim = dimension (e.g., 'left_y_axis')
    // v = variable on which statistic was computed
    // stat = statistic (e.g., 'mean')
    sampleStat(cohort_id, dim, v, stat) {
      if (cohort_id in this.sampleStats) {
        var ss1 = this.sampleStats[cohort_id];
        if (dim in ss1) {
          let ss2 = this.sampleStats[cohort_id][dim];
          if (v.id in ss2) {
            return ss2[v.id][stat];
          }
        }
      }
      return '-';
    },
    sampleMean(cohort_id, dim, v) {
      return this.sampleStat(cohort_id, dim, v, 'mean');
    },
    sampleMedian(cohort_id, dim, v) {
      return this.sampleStat(cohort_id, dim, v, 'median');
    },
    sampleIQR(cohort_id, dim, v) {
      return this.sampleStat(cohort_id, dim, v, 'iqr');
    },
    sampleDeviation(cohort_id, dim, v) {
      return this.sampleStat(cohort_id, dim, v, 'deviation');
    },
    sampleTtestPval(cohort_id, dim, v) {
      return this.sampleStat(cohort_id, dim, v, 'ttest_pval');
    },
    sampleCounts(cohort_id, dim, v) {
      if (v.data_category === 'Continuous') return [];
      let counts = this.sampleStat(cohort_id, dim, v, 'counts');
      // sort based on order of 'all' counts (largest to smallest)
      if (cohort_id != 'all') {
        let ss = this.sampleStat('all', dim, v, 'counts');
        let sorted_labels = ss.map(c => c.label);
        let l2c = {};
        counts.forEach(c => {
          l2c[c.label] = c;
        });
        counts = sorted_labels.map(l => l2c[l]);
      }
      return counts;
    },
    getVarNameClass(selVar) {
      return selVar
        ? 'text-subtitle-2 font-weight-black pl-1'
        : 'text-subtitle-2 font-weight-light pl-1';
    },
    getVarNameStyle(selVar) {
      return selVar ? 'font-weight: 800; color: black' : '';
    },
    getTdClass(selCol, selVar) {
      return selVar && selCol ? '' : 'font-weight-light';
    },
    getThClass(selCol, hdr) {
      if (hdr.text == 'p-Value') {
        return selCol && this.allCohortsSelected ? '' : 'font-weight-light';
      }
      return selCol ? '' : 'font-weight-light';
    },
    getSvgStyle(selCol) {
      return selCol ? '' : 'opacity: 0.2;';
    },
    getColTitleClass(selCol, hdr) {
      let s1 = 'text-subtitle-2 black--text pl-0 font-weight-black';
      let s2 = 'text-subtitle-2 black--text pl-0 font-weight-light';
      if (hdr.text == 'p-Value') {
        return selCol && this.allCohortsSelected ? s1 : s2;
      }
      return selCol ? s1 : s2;
    },
    getColTitleStyle(selCol, hdr) {
      let s1 = 'font-size: 120%; font-weight: 800; color: black;';
      let s2 = 'font-size: 120%;';
      if (hdr.text == 'p-Value') {
        return selCol && this.allCohortsSelected ? s1 : s2;
      }
      return selCol ? s1 : s2;
    },
    getColTitleCountClass(selCol) {
      return selCol
        ? 'text-subtitle-2 black--text'
        : 'text-subtitle-2 black--text font-weight-light';
    },
    getColTitleCountStyle(selCol) {
      return selCol ? 'font-weight: 800; color: black;' : '';
    },
    changeBGcolorClass(color) {
      var cls = color;
      return cls;
    },
    updateVisits(collection) {
      // build mapping from observation input variable to visit names
      this.var2visits = {};

      collection.observation_variables_list.forEach(ov => {
        var ov_id = ov.ontology.id;
        this.var2visits[ov_id] = {};

        if (ov['first_visit_event']) {
          this.var2visits[ov_id]['firstVisit'] = ov['first_visit_event'];
          this.var2visits[ov_id]['lastVisit'] = ov['last_visit_event'];
        } else {
          this.var2visits[ov_id]['firstVisit'] = ov['first_visit_num'];
          this.var2visits[ov_id]['lastVisit'] = ov['last_visit_num'];
        }
      });
    },
    getVariableName(v) {
      if (v.label in this.variableGroups['var2group']) {
        const group = this.variableGroups['var2group'][v.label];
        let name = group.prefix;
        return name.endsWith('_') ? name.substring(0, name.length - 1) : name;
      }
      if ('abbreviation' in v) return v['abbreviation'];
      var field = this.dimension2field[v.dimension_label];
      var vv = this.var2visits[v.observation_ontology.id];
      if (vv == null)
        return field == 'value'
          ? v.observation_ontology.abbreviation
          : v.observation_ontology.abbreviation + ' - ' + field;
      if (field in vv) {
        field = this.var2visits[v.observation_ontology.id][field];
      }
      return field == 'value'
        ? v.observation_ontology.abbreviation
        : v.observation_ontology.abbreviation + ' - ' + field;
    },
    selectVar(v, selected) {
      this.selectedVars[v.item.id] = selected;
      this.nSelectedVars = Object.keys(this.selectedVars).filter(
        i => this.selectedVars[i]
      ).length;
    },
    selectColumn(c, selected) {
      this.selectedCols[c.id] = selected;
      this.nSelectedCols = Object.keys(this.selectedCols).filter(
        i => this.selectedCols[i]
      ).length;

      // selected cohort ids
      let scids = {};
      Object.keys(this.selectedCols).forEach(sc => {
        if (this.selectedCols[sc]) {
          let cid = this.col2CohortId[sc];
          if (cid != 'all') {
            scids[cid] = 1;
          }
        }
      });

      // map cohort id to cohort
      let selCohorts = [];
      this.cohorts.forEach(c => {
        if (c.id in scids) {
          selCohorts.push(c);
        }
      });

      // emit new set of selected cohorts
      this.$emit('selectedCohorts', selCohorts);
    },
    addTable1Headers(hdrs, cnum) {
      let cn = cnum;
      // first visit
      if (this.selectedCols[++cn] || this.editMode) {
        hdrs.push({
          id: cn,
          text:
            this.summaryStat.value == 'mean_sd'
              ? 'Baseline Mean +/- SD'
              : 'Baseline Median (IQR)',
          value: 'mean',
          sortable: false,
        });
      }
      // last visit
      if (this.selectedCols[++cn] || this.editMode) {
        if (this.isLongitudinal) {
          hdrs.push({
            id: cn,
            text:
              this.summaryStat.value == 'mean_sd'
                ? 'Last Visit Mean +/- SD'
                : 'Last Visit Median (IQR)',
            value: 'lastVisit',
            sortable: false,
          });
        }
      }
      // p-value
      if (this.selectedCols[++cn] || this.editMode) {
        if (this.isLongitudinal) {
          hdrs.push({
            id: cn,
            text: 'p-Value',
            value: 'ttest_pval',
            sortable: false,
          });
        }
      }
    },
    addTable2Headers(hdrs, cnum) {
      let cn = cnum;
      let cohorts = [{ id: 'all', label: 'ALL' }, ...this.cohorts];
      cohorts.forEach(c => {
        if (this.selectedCols[++cn] || this.editMode) {
          hdrs.push({
            id: cn,
            text: c.label.replace(/^\[O\]_/, ''),
            value: c.label,
            sortable: false,
          });
        }
      });

      // p-value
      hdrs.push({
        id: ++cn,
        text: 'p-Value',
        value: 'p_value',
        sortable: true,
      });
    },
    updateHeaders() {
      var hdrs = [];
      let cnum = 0;

      // variable name
      hdrs.push({
        id: ++cnum,
        text: 'Sample characteristic',
        value: 'abbreviation',
        sortable: false,
      });

      if (this.displayMode === 'table1') {
        this.addTable1Headers(hdrs, cnum);
      } else if (this.displayMode === 'table2') {
        this.addTable2Headers(hdrs, cnum);
      }

      this.colHeaders = hdrs;
    },
    getDefaultDownloadPrefix() {
      let filename =
        'podvis_d' +
        this.collection.id +
        '_a' +
        this.analysis.index +
        '_table1';
      return filename;
    },
    getCsvData() {
      let data =
        'Sample characteristic,' +
        this.colHeaders
          .filter(h => this.selectedCols[h.id])
          .map(h => h.text)
          .join(',') +
        '\n';
      this.allVars
        .filter(v => this.selectedVars[v.id])
        .forEach(v => {
          let cvals = [this.getVariableName(v)];

          // continuous - single line
          if (v.data_category === 'Continuous') {
            let cnum = 1;
            this.colHeaders
              .filter(h => this.selectedCols[h.id])
              .map(() => {
                cnum += 1;
                let cval = null;
                // p-value column
                if (cnum == 4) {
                  cval = this.sampleTtestPval(v, 'right_y_axis');
                }
                // blank last visit column
                else if (
                  this.col2Axis[cnum] == 'right_y_axis' &&
                  !v.is_longitudinal &&
                  this.selectedCols[2]
                ) {
                  cval = '';
                } else {
                  cval =
                    this.summaryStat.value == 'mean_sd'
                      ? this.sampleMean(
                          this.col2CohortId[cnum],
                          this.col2Axis[cnum],
                          v
                        ) +
                        ' +/-' +
                        this.sampleDeviation(
                          this.col2CohortId[cnum],
                          this.col2Axis[cnum],
                          v
                        )
                      : this.sampleMedian(
                          this.col2CohortId[cnum],
                          this.col2Axis[cnum],
                          v
                        ) +
                        ' (' +
                        this.sampleIQR(
                          this.col2CohortId[cnum],
                          this.col2Axis[cnum],
                          v
                        ) +
                        ')';
                }
                cvals.push(cval);
              });
            data +=
              cvals
                .map(cv => {
                  return '"' + cv + '"';
                })
                .join(',') + '\n';
          }
          // categorical - multiple lines
          else {
            let chs = this.colHeaders.filter(h => this.selectedCols[h.id]);
            if (this.isLongitudinal) chs.pop();
            chs.forEach(() => {
              cvals.push('');
            });
            if (this.isLongitudinal) cvals.push(''); // p-value column
            data +=
              cvals
                .map(cv => {
                  return '"' + cv + '"';
                })
                .join(',') + '\n';
            let counts = [];
            let cnum = 1;
            chs.forEach(() => {
              cnum += 1;
              counts.push(this.sampleCounts(v, this.col2Axis[cnum]));
            });
            let ncats = counts[0].length;
            let self = this;

            for (var i = 0; i < ncats; ++i) {
              cvals = ['    ' + counts[0][i].label];
              let cnum = 1;
              counts.forEach(cts => {
                cnum += 1;
                // blank last visit column
                if (
                  self.col2Axis[cnum] == 'right_y_axis' &&
                  !v.is_longitudinal &&
                  this.selectedCols[2]
                ) {
                  cvals.push('');
                } else {
                  cvals.push(cts[i].count + ' (' + cts[i].percent + '%)');
                }
              });
              if (this.isLongitudinal) cvals.push(''); // p-value column
              data +=
                cvals
                  .map(cv => {
                    return '"' + cv + '"';
                  })
                  .join(',') + '\n';
            }
          }
        });
      return data;
    },
    exportTable(d) {
      this.exportTableDialog = false;
      if (d['format'] == 'csv') {
        let uri =
          'data:text/csv;charset=utf-8,' +
          encodeURIComponent(this.getCsvData());
        let link = document.createElement('a');
        link.setAttribute('href', uri);
        link.setAttribute('style', 'visibility: hidden');
        link.setAttribute('download', d['prefix'] + '.csv');
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 1000);
      } else if (d['format'] == 'pdf') {
        this.pdfFilename = d['prefix'];
        this.pdfFormat = d['pagesize'];
        this.pdfOrientation = d['orientation'];
        this.editMode = false;
        let hsv = this.highlightSelectedVar;
        this.highlightSelectedVar = false;
        this.updateTable();
        this.$nextTick(() => {
          this.$refs.vdt.generatePdf();
          this.$nextTick(() => {
            this.highlightSelectedVar = hsv;
          });
        });
      }
    },
    cohortSize(cid) {
      if (cid == 2) {
        return this.data.length;
      } else {
        return this.cohorts[cid - 3].subject_ids.length;
      }
    },
    getTRClass(ov) {
      return this.highlightSelectedVar && this.selectedVariables.includes(ov)
        ? 'selectedRow'
        : '';
    },
    tableRowClick(ov) {
      if (!this.editMode) {
        this.$emit('variableSelected', ov);
      }
    },
    format_pval(pval) {
      if (pval == null) {
        return '-';
      }
      if (pval < 0.001) {
        return '<0.001';
      }
      return `${format('.3f')(pval)}`;
    },
    getTitleClass() {
      let cls = 'pt-2 pb-2';
      if (!this.showTitle) cls = cls + ' font-weight-light';
      return cls;
    },
    getFootnoteClass() {
      let cls = 'pt-3 pl-2';
      if (!this.showFootnotes) cls = cls + ' font-weight-light';
      return cls;
    },
    updatePvalDict() {
      let pd = {};
      if (this.anovaPvals != null) {
        this.anovaPvals.forEach(a => {
          pd[a.label] = a;
        });
        this.pvalDict = pd;
      }
    },
    getPval(v) {
      if (v.label in this.pvalDict) {
        return this.pvalDict[v.label].pval;
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
tr.selectedRow {
  background-color: rgb(236, 177, 212) !important;
}
tr {
  text-align: left;
  padding: 8px;
  background-color: rgb(207, 212, 219);
}
tr:nth-child(odd) {
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
}
table tr > td {
  border-right: 1px dotted #000000;
}
table tr > th {
  border-right: 1px dotted #000000;
}
table tr > td:last-child {
  border-right: none;
}
table tr > th:last-child {
  border-right: none;
}
</style>
